module.exports = __webpack_public_path__ + "static/media/confirmed-circle-error.8044715d.svg";